import { createAction } from 'typesafe-actions';
import { ACTIONS } from './types';
import { IClientBet } from 'widgets/Roulette/types';

export const saveRoundBetAction = createAction(ACTIONS.SAVE_ROUND_BET)<IClientBet[]>();

export const saveRoundBetSuccessAction = createAction(ACTIONS.SAVE_ROUND_BET_SUCCESS)<
  IClientBet[] | null
>();

export const repeatBetAction = createAction(ACTIONS.REPEAT_BET)();

export const repeatBetSuccessAction = createAction(ACTIONS.REPEAT_BET_SUCCESS)();

export const clearRepeatBetAction = createAction(ACTIONS.CLEAR_REPEAT_BET)();

export const confirmRepeatBetAction = createAction(ACTIONS.CONFIRM_REPEAT_BET)();

export const errorRepeatBetAction = createAction(ACTIONS.ERROR_REPEAT_BET)();

export const resetRepeatBetAction = createAction(ACTIONS.RESET_REPEAT_BET)();
